import React, { Component } from 'react'
import { post, get } from '../../../utils/networking'
import { configs } from '../../../helpers/constants'
import $ from 'jquery'
import Tree from '../tree'
import TextInput from '../../../textInput'
import { notEmpty, isValid, emailAddres } from '../../../validations'
import './style.css'

const validationData = {
    email: [notEmpty, emailAddres]
}

export default class Referral extends Component {

    constructor(props) {
        super(props)
        this.state = {
            root: [],
            isLoaded: false,
            user: {},
            emails: [],
            email: "",
            isSuccessSendMail: false,
            isProsessing: false,
            searchID: "",
            searchString: "",
            userTemp: {},
            rootTemp: [],
            treeIDStack: [],
            rootID: ""
        }
    }

    componentDidMount() {

        this.setState({
            isLoaded: false
        })

        get('user/getMyProfile', "customer", result => {
            let { treeIDStack } = this.state
            treeIDStack.push(result.user.id)
            this.setState({
                user: result.user,
                isLoaded: true,
                userTemp: result.user,
                treeIDStack,
                rootID: result.user.id
            })
        })

        get('user/getTree', "customer", result => {
            this.setState({
                user: result.user,
                userTemp: result.user,
                root: result.users,
                isLoaded: true,
                rootTemp: result.users
            })
        })
    }

    handleCopyLink(el) {


        el = (typeof el === 'string') ? document.querySelector(el) : el;

        // handle iOS as a special case
        if (navigator.userAgent.match(/ipad|ipod|iphone/i) && el) {

            // save current contentEditable/readOnly status
            var editable = el.contentEditable;
            var readOnly = el.readOnly;

            // convert to editable with readonly to stop iOS keyboard opening
            el.contentEditable = true;
            el.readOnly = true;

            // create a selectable range
            var range = document.createRange();
            range.selectNodeContents(el);

            // select the range
            var selection = window.getSelection();
            selection.removeAllRanges();
            selection.addRange(range);
            el.setSelectionRange(0, 999999);

            // restore contentEditable/readOnly to original state
            el.contentEditable = editable;
            el.readOnly = readOnly;
        }
        else {
            el.select();
        }
        document.execCommand('copy');
    }

    handleAddMail() {
        if (isValid(validationData)) {
            let newList = this.state.emails;
            newList.push(this.state.email);
            this.setState({
                email: "",
                emails: newList
            })
        }
    }
    handleDeleteMail(email) {
        let newList = this.state.emails.filter(item => item != email);

        this.setState({
            emails: newList
        })
    }

    handleSend() {
        this.setState({
            isProsessing: true
        })
        post("/user/invite", this.state.emails, "customer", result => {
            this.setState({
                isSuccessSendMail: true,
                isProsessing: false
            })
        })
        setTimeout(() => {
            this.setState({
                isSuccessSendMail: false
            })
        }, 10000);
    }
    handleSearch() {
        this.setState({
            isLoaded: false
        })
        get("/user/searchTree/" + this.state.searchID, "customer", result => {
            this.setState({
                user: result.user,
                root: result.users,
                isLoaded: true
            })
        }, error => {
            this.setState({
                isLoaded: true
            })
        })
    }


    render() {
        let {
            root,
            isLoaded,
            user,
            emails,
            email,
            isSuccessSendMail,
            isProsessing,
            searchID,
            userTemp,
            rootTemp,
            treeIDStack,
            searchString,
            rootID
        } = this.state;
        return (
            <div id="referral_box">
                <div className="search-box">
                    {
                        (user.id != rootID) && <span className="go-up-bt" onClick={() => {
                            this.setState({
                                searchID: user.referalId
                            }, () => {
                                this.handleSearch()
                            })
                        }}><i className="fas fa-arrow-up"></i><span>Go one level up</span></span>
                    }
                    <TextInput
                        name="search"
                        label="Find"
                        value={searchString}
                        showPlaceholder={true}
                        placeholder="Referral ID"
                        validations={validationData.searchID}
                        onChange={(value) => this.setState({
                            searchString: value
                        })}
                    />
                    <span onClick={() => {
                        this.setState({
                            searchID: this.state.searchString
                        }, () => {
                            this.handleSearch()
                        })

                    }}><i className="fas fa-search"></i>Search</span>
                </div>
                {
                    isLoaded ? <div>
                        <table className="root">
                            <tbody>
                                <tr className="root_id">
                                    <td colSpan={2}>
                                        <img src={((user.avatar) ? (user.avatar) : (require('../../../assets/images/default_avatar.png')))} />
                                        <div className="referral_info" >
                                            <p className="name">{((user.firstName) ? user.firstName : user.name) + " [ " + user.id + " ]"}</p>
                                            <p>
                                                Email:
                                        {" " + user.email}
                                            </p>
                                            <p className="referral_point">
                                                Referral point:
                                        {" " + parseInt((user.referalPoint) ? user.referalPoint : 0)}
                                            </p>
                                            <p className="referral_point">
                                                Personal point:
                                        {" " + parseInt((user.personalPoint) ? user.personalPoint : 0)}
                                            </p>
                                        </div>
                                    </td>
                                </tr>
                                <tr className="root_line">
                                    <td className="line"></td>
                                    <td className="space"></td>
                                </tr>
                            </tbody>
                        </table>
                        {
                            (root.length > 0) ? <div className="referral">
                                {
                                    (isLoaded) ? <table className="tree">
                                        <tbody>
                                            <tr className="sub_id">
                                                <td colSpan={2}>
                                                    <table className="sub_list">
                                                        <tbody>
                                                            <tr className="sub_node">
                                                                {
                                                                    (root) ? root.map((item, i) =>
                                                                        <td className="node_detail" key={i}>
                                                                            <table className="node_table">
                                                                                <tbody>
                                                                                    <tr className="node_table_line">
                                                                                        <td className="space" style={{ borderTop: (i === 0) ? "none" : "2px solid #999" }}></td>
                                                                                        <td className="line" style={{ borderTop: (i === (root.length - 1)) ? "none" : "2px solid #999" }}></td>
                                                                                    </tr>
                                                                                    <tr className="node_table_value">
                                                                                        <td colSpan={2} onClick={() => {
                                                                                            this.setState({
                                                                                                searchID: item.id
                                                                                            }, () => {
                                                                                                this.handleSearch()
                                                                                            })
                                                                                        }}>
                                                                                            <img src={((item.avatar) ? (configs.api_domain + item.avatar) : (require('../../../assets/images/default_avatar.png')))} />
                                                                                            <span className="referral_id">{(item.referalPoint + item.personalPoint)}
                                                                                                {/* <img src="data:image/svg+xml;utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTkuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDUxMiA1MTIiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDUxMiA1MTI7IiB4bWw6c3BhY2U9InByZXNlcnZlIiB3aWR0aD0iMjRweCIgaGVpZ2h0PSIyNHB4Ij4KPGc+Cgk8Zz4KCQk8cGF0aCBkPSJNNDIyLjUwMywyNzAuNjEzYy00LjExNSwwLTcuNDUxLDMuMzM2LTcuNDUxLDcuNDUxYzAsNS4yMTctNC4yNDQsOS40NjEtOS40NjEsOS40NjFjLTUuMjE2LDAtOS40NjEtNC4yNDQtOS40NjEtOS40NjEgICAgYzAtNC4xMTYtMy4zMzYtNy40NTEtNy40NTEtNy40NTFzLTcuNDUxLDMuMzM2LTcuNDUxLDcuNDUxYzAsMTMuNDM0LDEwLjkzLDI0LjM2MywyNC4zNjMsMjQuMzYzICAgIGMxMy40MzMsMCwyNC4zNjMtMTAuOTMsMjQuMzYzLTI0LjM2M0M0MjkuOTU0LDI3My45NDcsNDI2LjYxOCwyNzAuNjEzLDQyMi41MDMsMjcwLjYxM3oiIGZpbGw9IiMwMDAwMDAiLz4KCTwvZz4KPC9nPgo8Zz4KCTxnPgoJCTxwYXRoIGQ9Ik00OTIuNDQ0LDI3MS44M2wtMjAuOTcyLTYuNzE4Yy0yLjY4Ni0wLjg2MS00LjgwMy0zLjAwNS01LjY2Mi01LjczNmMtNC40Mi0xNC4wNTMtMTEuMDktMjcuMjQ2LTE5LjgyNS0zOS4yMTQgICAgYy0zLjk4MS01LjQ1NS04LjQwOC0xMC42NjQtMTMuMjQ0LTE1LjYyM2MzLjA5NC0xMy41NzMsNC43NzYtMjguOTM0LDQuNTU4LTQyLjIwNWMtMC4zMTItMTguOTg1LTQuMTA2LTMwLjEyLTExLjU5OC0zNC4wNDQgICAgYy00LjAzNS0yLjExNi0xNi4zMTUtOC41NDQtODIuNzgyLDIxLjg4MmMtMS41NzQsMC43Mi0zLjA0NCwxLjYwNy00LjQwNSwyLjYyM2MtNC40ODEtMS4yMDQtOS4wNjEtMi4zMTgtMTMuNjY5LTMuMzE4ICAgIGMtMC41NTUtMC4xMjEtMS4xMjctMC4yMjgtMS42ODYtMC4zNDZjNS4zODYtMTEuNzY2LDguNTMxLTI0LjU0NSw5LjEyMi0zNy43MzdjMC4xODQtNC4xMTItMi45OTktNy41OTQtNy4xMTEtNy43NzcgICAgYy00LjEwMS0wLjIwNC03LjU5NCwyLjk5OC03Ljc3Nyw3LjExYy0wLjk3MSwyMS42OTEtOS45NjksNDIuMS0yNS4zMzUsNTcuNDY3Yy05LjE4MSw5LjE4MS0xOS45MzEsMTUuODUtMzEuMzg4LDIwLjA1ICAgIGMtMTkuODY5LTIuNzg4LTQwLjEwNy0yLjc4OC01OS45NzYsMGMtMTEuNDU4LTQuMi0yMi4yMDctMTAuODY5LTMxLjM4OC0yMC4wNWMtMTYuMzk0LTE2LjM5NC0yNS40MjMtMzguMTkxLTI1LjQyMy02MS4zNzYgICAgYzAtMjMuMTg2LDkuMDI5LTQ0Ljk4MiwyNS40MjMtNjEuMzc2YzE2LjM5NC0xNi4zOTUsMzguMTkyLTI1LjQyNCw2MS4zNzYtMjUuNDI0YzIzLjE4NCwwLDQ0Ljk4Miw5LjAyOSw2MS4zNzYsMjUuNDI0ICAgIGM2LjU4OCw2LjU4OCwxMi4wMzIsMTQuMTA2LDE2LjE4MSwyMi4zNDNjMS44NTEsMy42NzYsNi4zMzIsNS4xNTYsMTAuMDA3LDMuMzA0YzMuNjc2LTEuODUsNS4xNTUtNi4zMzEsMy4zMDQtMTAuMDA2ICAgIGMtNC44NjMtOS42NTktMTEuMjQtMTguNDY2LTE4Ljk1My0yNi4xOGMtMTkuMjA5LTE5LjIwOS00NC43NDktMjkuNzg4LTcxLjkxNC0yOS43ODhjLTI3LjE2NSwwLTUyLjcwNSwxMC41NzktNzEuOTE0LDI5Ljc4OCAgICBjLTE5LjIwOSwxOS4yMS0yOS43ODgsNDQuNzQ5LTI5Ljc4OCw3MS45MTRzMTAuNTc5LDUyLjcwNSwyOS43ODgsNzEuOTE0YzUuNTQxLDUuNTQxLDExLjU2OSwxMC4zMDYsMTcuOTQ1LDE0LjI5OCAgICBjMC4wMDIsMCwwLjAwNC0wLjAwMSwwLjAwNi0wLjAwMWMtNC42MzMsMS4yMDQtOS4yMzEsMi41NTYtMTMuNzc4LDQuMDc2Yy0zLjkwMywxLjMwNS02LjAwOSw1LjUyNi00LjcwNCw5LjQzICAgIGMxLjMwNCwzLjkwMyw1LjUyNyw2LjAwOSw5LjQyOSw0LjcwNWM0MC42MzYtMTMuNTg1LDg1LjM5Ni0xMy41ODUsMTI2LjAzMiwwYzAuNzg0LDAuMjYyLDEuNTgsMC4zODYsMi4zNjMsMC4zODYgICAgYzMuMTE3LDAsNi4wMjMtMS45NzIsNy4wNjYtNS4wOTFjMS4zMDUtMy45MDMtMC44MDEtOC4xMjUtNC43MDQtOS40M2MtNC41NDctMS41Mi05LjE0NS0yLjg3My0xMy43NzgtNC4wNzYgICAgYzAuMDAyLDAsMC4wMDQsMC4wMDEsMC4wMDYsMC4wMDFjNi4zNzctMy45OTIsMTIuNDA0LTguNzU3LDE3Ljk0NS0xNC4yOThjNC45MDItNC45MDIsOS4yMjktMTAuMjU1LDEyLjk4Ni0xNS45NDQgICAgYzIuMDU0LDAuMzk5LDQuMDkzLDAuODE3LDYuMTAyLDEuMjUzYzIuNjc2LDAuNTgxLDUuMzQsMS4yMDUsNy45OCwxLjg2Yy0wLjA4MywwLjMyNC0wLjE2OCwwLjY0Ny0wLjIzNywwLjk3NiAgICBjLTMuNjM0LDE3LjI0NS0zLjM5OCwzMi40OTcsMC43MDEsNDUuMzNjMy42ODQsMTEuNTM1LDEwLjMzMywyMC44OCwxOS43NiwyNy43NzdjMTEuMTExLDguMTI4LDI0LjUyNSwxMS42MzksMzYuNjc2LDExLjYzOSAgICBjOS4xNDUsMCwxNy41NzYtMS45OSwyMy43NjgtNS40OTdjNy4wMDQtMy45NjcsMTIuODcyLTEyLjMyNiwxNy41MTctMjQuODc2YzIuMTQ3LDIuNTA2LDQuMTgyLDUuMDczLDYuMSw3LjcwMSAgICBjNy43NzcsMTAuNjU0LDEzLjcxNCwyMi4zOTYsMTcuNjQ2LDM0Ljg5OGMyLjMwOSw3LjM0Myw4LjA0MSwxMy4xMjEsMTUuMzMyLDE1LjQ1OGwyMC45NzIsNi43MTggICAgYzUuNTAzLDEuNzYzLDkuMiw2LjgyOCw5LjIsMTIuNjA2djM0Ljc3NWMwLDUuNzc4LTMuNjk3LDEwLjg0My05LjIsMTIuNjA2bC0zMy43ODksMTAuODIzICAgIGMtNS40MDYsMS43MzMtOS45ODEsNS40NDgtMTIuODgyLDEwLjQ2MmMtMTMuMjc1LDIyLjk0Mi0zNC4xNDYsNDEuOTI3LTYyLjAzNyw1Ni40MjhjLTMuMjIyLDEuNjc3LTUuNDU0LDQuNjc2LTYuMTI2LDguMjMgICAgbC0xMC44MjIsNTcuMzAzYy0wLjI5OSwxLjU3OS0xLjY4MiwyLjcyNC0zLjI4OSwyLjcyNGgtMzUuMTg3Yy0xLjYwNywwLTIuOTktMS4xNDYtMy4yODktMi43MjRsLTUuOTk0LTMxLjY2OSAgICBjLTEuMTgtNi4yMzEtNy4wMjQtMTAuMzctMTMuMzE0LTkuNDE3Yy0xNS4xNTcsMi4yOTItMzAuNzc1LDMuNDUzLTQ2LjQxOCwzLjQ1M2MtMTEuNjM4LDAtMjMuMTI3LTAuNjQ5LTM0LjE1LTEuOTMgICAgYy02LjA5NS0wLjcwMS0xMS43NzMsMy40NTQtMTIuOTEyLDkuNDcybC01LjY5NiwzMC4wOTFjLTAuMjk5LDEuNTc5LTEuNjgyLDIuNzI0LTMuMjg5LDIuNzI0aC0zNS4xODcgICAgYy0xLjYwNywwLTIuOTktMS4xNDYtMy4yOTMtMi43NDhsLTEwLjQyLTU0LjEyMmMtMC42NzEtMy40ODctMi44NjEtNi40NTItNi4wMTItOC4xMzVDOTYuMjUsNDAxLjU5NSw3MS4xMiwzNTkuMTkxLDcxLjEyLDMwNC4zNTEgICAgYzAtMjcuNzA4LDYuMDYyLTUyLjIwOSwxOC4wMTctNzIuODI1YzExLjE1Ni0xOS4yMzksMjcuNDUtMzUuMTQ2LDQ4LjQyOS00Ny4yODFjMy41NjItMi4wNjEsNC43NzktNi42MTksMi43MTktMTAuMTgyICAgIGMtMi4wNi0zLjU2Mi02LjYxOC00Ljc3Ny0xMC4xODEtMi43MTlDODkuNDI1LDE5NC44NzYsNjQuODksMjMxLjE4LDU4LjEzNSwyNzcuMjl2LTAuMDAxYy0wLjcxNy0wLjA2NS0xLjQzNS0wLjEyNy0yLjE1LTAuMjAxICAgIGMwLjEzLTQuOTc1LTAuNzctOS45OTUtMi43My0xNC44NjdjLTQuMzIzLTEwLjc0Ni0xMy4yMDMtMTguNTAyLTIyLjYyNC0xOS43NTljLTcuNDI0LTAuOTk0LTE0LjQ4OSwyLjE1OC0xOS4zOTIsOC42MzYgICAgYy03LjEwOSw5LjM5NC01Ljk1LDE2LjgyOC0zLjcyNywyMS40MWMzLjc1Myw3LjczMywxMy40LDEzLjIwMywyOS40MDksMTYuNjQyYy0wLjQ0LDAuNjU5LTAuOTI0LDEuMzIxLTEuNDU0LDEuOTg2ICAgIGMtOS40NTksMTEuODYzLTIwLjYwMywxNC40ODYtMjcuODM5LDE0LjczM0MzLjM5MiwzMDYuMDEyLDAsMzA5LjQxMywwLDMxMy42NTJ2MC4wMzZjMCw0LjE4MSwzLjI5OSw3LjU5MSw3LjQ3Niw3Ljc4MiAgICBjMC41MzUsMC4wMjUsMS4wOTQsMC4wMzgsMS42NzYsMC4wMzhjOS4xNTYsMCwyMy44NTEtMy4zNzcsMzcuOTY5LTIxLjA4YzIuMjI5LTIuNzk0LDQuMDQ1LTUuNzQyLDUuNDQxLTguNzg4ICAgIGMxLjQwNiwwLjE1OSwyLjc1NywwLjI5NSw0LjA1MSwwLjQxNWMwLTAuMDAzLDAtMC4wMDUsMC4wMDEtMC4wMDhjLTAuMjU0LDQuMDM4LTAuMzk1LDguMTM1LTAuMzk1LDEyLjMwNCAgICBjMCwzMS4wMjgsNy4zOTcsNTguNjkzLDIxLjk4NCw4Mi4yM2MxMy40NSwyMS43LDMyLjcwNywzOS40NjgsNTcuMjU1LDUyLjgzbDEwLjEzLDUyLjYxNmMxLjYyOSw4LjYwOCw5LjE3LDE0Ljg1NiwxNy45MzEsMTQuODU2ICAgIGgzNS4xODdjOC43NjEsMCwxNi4zMDItNi4yNDgsMTcuOTMxLTE0Ljg1Nmw1LjE1LTI3LjIwOGMxMC42OTYsMS4xMzMsMjEuNzcsMS43MDcsMzIuOTY1LDEuNzA3YzE1LjM2LDAsMzAuNzAyLTEuMDcsNDUuNjU0LTMuMTgyICAgIGw1LjQyOSwyOC42ODVjMS42Myw4LjYwOCw5LjE3MSwxNC44NTUsMTcuOTMxLDE0Ljg1NWgzNS4xODdjOC43NjEsMCwxNi4zMDItNi4yNDgsMTcuOTMyLTE0Ljg1OWwxMC41MzctNTUuNzkxICAgIGMyOS43NjgtMTUuNzQxLDUyLjIwNi0zNi40MTksNjYuNzA0LTYxLjQ3NWMxLjA0NS0xLjgwNiwyLjY1NC0zLjEzMSw0LjUzLTMuNzMybDMzLjc4OC0xMC44MjMgICAgQzUwNC4xNDEsMzU2LjQ1NSw1MTIsMzQ1LjY4Niw1MTIsMzMzLjQwM3YtMzQuNzc1QzUxMiwyODYuMzQ2LDUwNC4xNDEsMjc1LjU3Nyw0OTIuNDQ0LDI3MS44M3ogTTQyMS4yNzgsMTgzLjI3MyAgICBjLTIuODY4LDI0LjUyNi0xMC41NjEsNDUuNTA2LTE4LjI5MSw0OS44ODRjLTguNzg2LDQuOTc3LTI5LjA3MSw1LjkzOC00NC4zMDEtNS4yMDNjLTE1LjI0OC0xMS4xNTQtMjAuMzIzLTMxLjIxMi0xNC42NzgtNTguMDA2ICAgIGMwLTAuMDAxLDAtMC4wMDEsMC0wLjAwMWMwLjU2Ny0yLjY5MSwyLjQ3OS01LjAxOSw1LjExNC02LjIyNWMzNy4zMDQtMTcuMDc2LDU4LjgxMS0yMi42NjEsNjYuODAxLTIyLjY2MSAgICBjMS4yMDYsMCwyLjEwNCwwLjEyNywyLjcwMiwwLjM2MUM0MjEuMDI1LDE0My45OCw0MjQuMTczLDE1OC41MjEsNDIxLjI3OCwxODMuMjczeiBNMjAuOTIxLDI2Ni4wMDEgICAgYy0wLjc3MS0xLjU5LDEuMDQ5LTQuMzg1LDIuMjAzLTUuOTExYzEuODI5LTIuNDE2LDMuNTE0LTIuOTEsNC43ODctMi45MWMwLjI2OSwwLDAuNTIsMC4wMjIsMC43NSwwLjA1MyAgICBjMy40MjYsMC40NTcsOC4yMjYsNC4yMjcsMTAuNzY5LDEwLjU0OGMwLjU5OSwxLjQ4OCwxLjM3NywzLjk1MywxLjU1OSw3LjAyN0MzMC42NzQsMjcyLjY3MSwyMi42NiwyNjkuNTksMjAuOTIxLDI2Ni4wMDF6IiBmaWxsPSIjMDAwMDAwIi8+Cgk8L2c+CjwvZz4KPGc+Cgk8Zz4KCQk8cGF0aCBkPSJNMjM3LjkxOCw5OC4yNzdWNzEuNjEzYzkuMTk1LDAuNjU3LDEyLjYxMSw0Ljg2LDE1Ljc2Myw0Ljg2YzMuOTQxLDAsNS43OC00Ljk5MSw1Ljc4LTcuNDg3ICAgIGMwLTYuNDM3LTEyLjYxMS05LjE5NS0yMS41NDMtOS40NThWNTUuOThjMC0xLjU3Ni0xLjk3MS0zLjAyMS0zLjk0MS0zLjAyMWMtMi4yMzQsMC0zLjgxLDEuNDQ1LTMuODEsMy4wMjF2My44MDkgICAgYy0xMi40NzksMS4zMTQtMjQuOTU4LDcuODgyLTI0Ljk1OCwyNC40MzNjMCwxNi44MTQsMTMuMTM2LDIxLjU0MywyNC45NTgsMjUuNzQ2djMwLjg2OSAgICBjLTEzLjM5OS0xLjA1MS0xNi45NDUtMTAuMjQ2LTIxLjI4LTEwLjI0NmMtMy4yODQsMC02LjA0Miw0LjMzNS02LjA0Miw3LjQ4OGMwLDYuNDM2LDExLjAzNCwxNS4yMzcsMjcuMzIyLDE1LjVoMHY0LjA3MiAgICBjMCwxLjU3NiwxLjU3NywzLjAyMSwzLjgxLDMuMDIxYzEuOTcxLDAsMy45NDEtMS40NDUsMy45NDEtMy4wMjF2LTQuNDY2YzE0LjE4Ny0xLjk3MSwyMy45MDctMTAuOTAzLDIzLjkwNy0yNy4wNiAgICBDMjYxLjgyNSwxMDguMjYxLDI0OS4zNDYsMTAyLjQ4LDIzNy45MTgsOTguMjc3eiBNMjMwLjk1NSw5NS43ODJjLTYuOTYyLTIuNjI3LTEyLjYxLTUuMzg1LTEyLjYxLTEyLjg3MiAgICBjMC02LjgzMSw1LjI1NC0xMC4xMTUsMTIuNjEtMTEuMDM0Vjk1Ljc4MnogTTIzNy4xMjksMTQwLjU3NHYtMjcuNzE2YzYuNDM2LDIuNzU4LDExLjU1OSw2LjQzNiwxMS41NTksMTQuNzExICAgIEMyNDguNjg4LDEzNS4wNTgsMjQ0LjIyMiwxMzkuMjYxLDIzNy4xMjksMTQwLjU3NHoiIGZpbGw9IiMwMDAwMDAiLz4KCTwvZz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8L3N2Zz4K" /> */}
                                                                                            </span>
                                                                                            <div className="referral_info" >
                                                                                                <span>{"ID: " + item.id}</span>
                                                                                                <span>{"Name: " + item.name}</span>
                                                                                                <span>{"Phone: " + item.phone}</span>
                                                                                                <span>{"Point: " + (item.referalPoint + item.personalPoint)}</span>
                                                                                            </div>
                                                                                        </td>
                                                                                    </tr>
                                                                                </tbody>
                                                                            </table>
                                                                        </td>
                                                                    ) : ""
                                                                }
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table> : <div style={{ width: "200px", height: "200px", margin: "50px auto", backgroundImage: "url(" + require('../../../assets/images/loader.gif') + ")", backgroundRepeat: "no-repeat", backgroundPosition: "50% 50%" }}></div>
                                }
                            </div> : <div className="root-empty"> Empty</div>
                        }
                    </div> : <div style={{ height: "385px" }}>
                            <div className="spinner">
                                <div className="rect1"></div>
                                <div className="rect2"></div>
                                <div className="rect3"></div>
                                <div className="rect4"></div>
                                <div className="rect5"></div>
                            </div>
                        </div>
                }
                <div className="share-code">
                    <span className="title">Share your referral code now!</span>
                    <div className="link">
                        <div className="link-detail">
                            <span> <span>Referral</span> Link</span>
                            <input id="link_value" type="text" value={configs.domain + "register?referralcode=" + ((user.id) ? user.id : "")} />
                        </div>
                        <span className="bt_clipboard" onClick={() => this.handleCopyLink("#link_value")}><i className="fas fa-paste"></i><span>Copy Link</span></span>
                    </div>
                    <div className="share-mail">
                        <span className="title">Send mail to your friends</span>
                        <div className="mails_address">
                            <p>To</p>
                            <div className="add_mail">
                                <TextInput
                                    name="email"
                                    label="Email"
                                    value={email}
                                    showPlaceholder={true}
                                    placeholder="Email"
                                    validations={validationData.email}
                                    onChange={(value) => this.setState({
                                        email: value
                                    })}
                                />
                                <span className="bt_add" onClick={() => this.handleAddMail()}>Add</span>
                            </div>
                            <div className="list">
                                {
                                    emails.map((item, i) =>
                                        <div key={i}>
                                            <span className="mail_value">{item}</span>
                                            <i className="fas fa-times-circle" onClick={() => this.handleDeleteMail(item)}></i>
                                        </div>
                                    )
                                }
                            </div>
                            {(isSuccessSendMail) ? <p className="book-notify">You have successful invite your friend.</p> : ""}
                            <span className="bt_send" onClick={() => this.handleSend('#link_value')}>{(isProsessing) ? "Waiting..." : "Send"}</span>
                        </div>
                    </div>
                </div>
            </div >
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/user/referral/index.js